import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const UnavailableDate = ApplicationRecord.extend({
  attrs: {
    date: attr({ type: Number }),
    description: attr(),
    reschedulable_to: attr({ type: Date }),
  },
  static: {
    endpoint: '/unavailable_dates',
    jsonapiType: 'deliveries-unavailable_dates',
  },
});

export default UnavailableDate;
